import {
  GET_LIAISONS_REQUEST,
  GET_LIAISONS_SUCCESS,
  GET_LIAISONS_FAIL,
  GET_SINGLE_LIAISON_REQUEST,
  GET_SINGLE_LIAISON_SUCCESS,
  GET_SINGLE_LIAISON_FAIL,
  ADD_LIAISON_SUCCESS,
  UPDATE_LIAISON_SUCCESS,
  DELETE_LIAISON_SUCCESS,
  INVALIDATE_LIAISONS_CACHE
} from "./liaisonTypes";

const initialState = {
  loading: false,
  liaisons: [],
  singleLiaison: null,
  cacheValid: false,
  lastFetched: null,
  error: null
};

const liaisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIAISONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_LIAISONS_SUCCESS:
      return {
        ...state,
        loading: false,
        liaisons: action.payload,
        cacheValid: true,
        lastFetched: Date.now(),
        error: null
      };
    case GET_LIAISONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_SINGLE_LIAISON_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_SINGLE_LIAISON_SUCCESS: {
      const existingIndex = state.liaisons.findIndex((l) => l._id === action.payload._id);
      const updatedLiaisons =
        existingIndex >= 0 ? state.liaisons.map((l, idx) => (idx === existingIndex ? action.payload : l)) : [...state.liaisons, action.payload];
      return {
        ...state,
        loading: false,
        singleLiaison: action.payload,
        liaisons: updatedLiaisons,
        error: null
      };
    }
    case GET_SINGLE_LIAISON_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ADD_LIAISON_SUCCESS:
      return {
        ...state,
        cacheValid: false,
        liaisons: action.payload ? [...state.liaisons, action.payload] : state.liaisons
      };
    case UPDATE_LIAISON_SUCCESS:
      return {
        ...state,
        liaisons: state.liaisons.map((l) => (l._id === action.payload._id ? { ...l, ...action.payload } : l)),
        singleLiaison: state.singleLiaison?._id === action.payload._id ? { ...state.singleLiaison, ...action.payload } : state.singleLiaison
      };
    case DELETE_LIAISON_SUCCESS:
      return {
        ...state,
        liaisons: state.liaisons.filter((l) => l._id !== action.payload),
        cacheValid: false
      };
    case INVALIDATE_LIAISONS_CACHE:
      return {
        ...state,
        cacheValid: false
      };
    default:
      return state;
  }
};

export default liaisonReducer;
